import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin, Clock, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

const LocationSelector = () => {
  const navigate = useNavigate();

  const handleLiepajaClick = () => {
    localStorage.setItem('locationSelected', 'liepaja');
    navigate('/mikado'); // Redirects to closed page
  };

  const handleRigaClick = () => {
    window.location.href = 'https://rozedinapoli.lv/home';
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 flex items-center justify-center p-4">
      <div className="max-w-6xl w-full">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-6xl md:text-7xl font-bold text-gray-900 mb-6 tracking-tight">
            IZVĒLIES RESTORĀNU
          </h1>
          <p className="text-xl text-gray-600">
            Izvēlies savu pilsētu
          </p>
        </div>

        {/* Location Cards */}
        <div className="grid md:grid-cols-2 gap-8">
          {/* Pizza */}
          <div className="cursor-pointer overflow-hidden relative group shadow-2xl rounded-2xl">
            {/* Background Image - High Quality */}
            <div 
              className="absolute inset-0 bg-cover bg-center group-hover:scale-105 transition-transform duration-500"
              style={{
                backgroundImage: "url('https://customer-assets.emergentagent.com/job_mikado-eats/artifacts/6bwezy1a_fon%20picca.JPG')",
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            />
            {/* Dark overlay for text readability */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-black/20"></div>
            
            <div className="p-8 relative z-10">
              <div className="text-center mb-8">
                <h2 className="text-5xl font-bold text-white mb-6 drop-shadow-lg">PIZZA</h2>
                <p className="text-2xl text-white font-semibold mb-2 drop-shadow-md">Roze di Napoli</p>
                <p className="text-gray-100 font-medium drop-shadow">Itāļu Pica</p>
              </div>

              <div className="space-y-4 mb-8 bg-white/90 backdrop-blur-sm rounded-xl p-4">
                <div className="flex items-start space-x-3 text-gray-800">
                  <MapPin className="w-5 h-5 mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-semibold">Liepu iela 9, Liepāja, Latvija</p>
                    <p className="text-sm text-gray-700">+371 28717331</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3 text-gray-800">
                  <Clock className="w-5 h-5 mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-semibold">Darba Laiks:</p>
                    <p className="text-sm">P - C: 12:00 - 21:00</p>
                    <p className="text-sm">Pk - S: 12:00 - 22:00</p>
                    <p className="text-sm">Svētdiena: 12:00 - 21:00</p>
                  </div>
                </div>
              </div>

              <Button
                onClick={handleRigaClick}
                className="w-full bg-red-600 hover:bg-red-700 text-white text-lg py-6 rounded-xl font-bold shadow-2xl"
              >
                IENĀKT
              </Button>
            </div>
          </div>

          {/* Sushi - CLOSED */}
          <div className="cursor-pointer overflow-hidden relative group shadow-2xl rounded-2xl">
            {/* Background Image - High Quality */}
            <div 
              className="absolute inset-0 bg-cover bg-center transition-transform duration-500"
              style={{
                backgroundImage: "url('https://customer-assets.emergentagent.com/job_mikado-eats/artifacts/dg9u7yds_KOPBILDE.JPG')",
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                filter: 'grayscale(50%)'
              }}
            />
            {/* Dark overlay for text readability */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/60 to-black/40"></div>
            
            <div className="p-8 relative z-10">
              <div className="text-center mb-8">
                <h2 className="text-5xl font-bold text-white mb-6 drop-shadow-lg">SUSHI</h2>
                <p className="text-2xl text-white font-semibold mb-2 drop-shadow-md">Mikado Sushi</p>
                <p className="text-gray-100 font-medium drop-shadow">Panāzijas Virtuve</p>
              </div>

              {/* CLOSED Banner */}
              <div className="bg-red-600 text-white text-center py-4 px-6 rounded-xl mb-6">
                <p className="text-xl font-bold mb-1">ĪSLAICĪGI SLĒGTS</p>
                <p className="text-sm">Aicinām apmeklēt Restorānu Roze</p>
              </div>

              <div className="space-y-4 mb-8 bg-white/90 backdrop-blur-sm rounded-xl p-4">
                <div className="flex items-start space-x-3 text-gray-800">
                  <MapPin className="w-5 h-5 mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-semibold">Liepu iela 9, Liepāja, Latvija</p>
                    <p className="text-sm text-gray-700">+371 28717331</p>
                  </div>
                </div>
              </div>

              <Button
                onClick={handleLiepajaClick}
                className="w-full bg-gray-600 hover:bg-gray-700 text-white text-lg py-6 rounded-xl font-bold shadow-2xl"
              >
                UZZINĀT VAIRĀK
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationSelector;
